export const externalLicensePoolsPerPage = 20;
